import { gql } from "@apollo/client";

export const GET_IPS_GROUP_DEF_DATA = gql`
  {
    getIpsDeficiencyGroups {
      groupId
      groupName
      groupDescription
      groupCreatedBy
      groupCreatedOn
      groupModifiedBy
      groupModifiedOn
      groupPoints
    }
    getPublicIpsDeficiencyPoints {
      typeCode
      typeDesc
      point
      maxPoint
      ruleName
      reportText
      severity
      daysToCorrect
      lastUpdateDate
      lastUpdateUser
      deactivated
    }
    getIpsDeficiencyGroupNextVal {
      value
    }
  }
`;
export const GET_IPS_DEFICIENCY_GROUPS = gql`
  query IpsDeficiencyGroups {
    getIpsDeficiencyGroups {
      groupId
      groupName
      groupDescription
      groupCreatedBy
      groupCreatedOn
      groupModifiedBy
      groupModifiedOn
      groupPoints
    }
  }
`;

/*export const GET_IPS_DEFICIENCY_GROUP_NEXTVAL = gql`
  query IpsDeficiencyGroupNextVal {
    getIpsDeficiencyGroupNextVal
  }
`;*/

export const ADD_IPS_DEFICIENCY_GROUP = gql`
  mutation AddIpsDeficiencyGroup(
    $groupName: String
    $groupDescription: String
    $groupCreatedBy: String
    $groupCreatedOn: Date
    $groupPoints: Int
    $groupDeficiencies: [AddIpsDeficienciesInput]
  ) {
    addIpsDeficiencyGroup(
      AddIpsDeficiencyGroupInput: {
        groupName: $groupName
        groupDescription: $groupDescription
        groupCreatedBy: $groupCreatedBy
        groupCreatedOn: $groupCreatedOn
        groupPoints: $groupPoints
        groupDeficiencies: $groupDeficiencies
      }
    ) {
      status
      message
    }
  }
`;

export const UPDATE_IPS_DEFICIENCY_GROUP = gql`
  mutation UpdateIpsDeficiencyGroup(
    $groupId: Int!
    $groupName: String
    $groupDescription: String
    $groupModifiedBy: String
    $groupModifiedOn: Date
    $groupPoints: Int
    $groupDeficiencies: [AddIpsDeficienciesInput]
  ) {
    updateIpsDeficiencyGroup(
      UpdateIpsDeficiencyGroupInput: {
        groupId: $groupId
        groupName: $groupName
        groupDescription: $groupDescription
        groupModifiedBy: $groupModifiedBy
        groupModifiedOn: $groupModifiedOn
        groupPoints: $groupPoints
        groupDeficiencies: $groupDeficiencies
      }
    ) {
      status
      message
    }
  }
`;

export const DELETE_IPS_DEFICIENCY_GROUP = gql`
  mutation DeleteIpsDeficiencyGroup($groupId: Int!) {
    deleteIpsDeficiencyGroup(DeleteIpsDeficiencyGroupInput: { groupId: $groupId }) {
      status
      message
    }
  }
`;

export const GET_IPS_DEFICIENCY_GROUP_BY_GROUP_ID = gql`
  query IpsDeficiencyGroupByGroupId($groupId: Int!) {
    getIpsDeficiencyGroupByGroupId(groupId: $groupId) {
      groupId
      groupName
      groupCreatedBy
      groupCreatedOn
      groupModifiedBy
      groupModifiedOn
      groupPoints
      groupDeficiencies {
        groupId
        typeCode
        ruleName
      }
    }
  }
`;

export const INSERT_IPS_DEFICIENCY_GROUP_TO_DEFICIENCY = gql`
  mutation InsertIpsDeficiencyGroupToDeficiency(
    $groupId: Int!
    $deficiencyId: String!
    $createdBy: String
    $createdOn: Date
  ) {
    insertIpsDeficiencyGroupToDeficiency(
      IpsDeficiencyGroupToDeficiencyInput: {
        groupId: $groupId
        deficiencyId: $deficiencyId
        createdBy: $createdBy
        createdOn: $createdOn
      }
    ) {
      status
      message
    }
  }
`;

export const DELETE_IPS_DEFICIENCY_GROUP_TO_DEFICIENCY = gql`
  mutation DeleteIpsDeficiencyGroupToDeficiency(
    $groupId: Int!
    $deficiencyId: String
    $createdBy: String
    $createdOn: Date
  ) {
    deleteIpsDeficiencyGroupToDeficiency(
      IpsDeficiencyGroupToDeficiencyInput: {
        groupId: $groupId
        deficiencyId: $deficiencyId
        createdBy: $createdBy
        createdOn: $createdOn
      }
    ) {
      status
      message
    }
  }
`;
